export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7493.1b912fe7.jpg";